import React, { useState } from 'react'
import PropTypes from 'prop-types'
import InputWrapper from './InputWrapper'
import { Upload, message } from 'antd'
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons'

const baseUrl = process.env.REACT_APP_API_BASE_URL

const UploadComponent = ({ imageUrl, defaultValue, uploadButton, ...rest }) => {
  let url
  if (defaultValue) {
    url = `${baseUrl}/api/Containers/witsawa-iot/download/${defaultValue}`
  }
  if (imageUrl) {
    url = imageUrl
  }
  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!')
    }
    const isLt2M = file.size / 1024 / 1024 < 2
    if (!isLt2M) {
      message.error('Image must smaller than 2MB!')
    }
    return isJpgOrPng && isLt2M
  }

  return (
    <Upload
      listType="picture-card"
      className="avatar-uploader"
      showUploadList={false}
      action={`${baseUrl}/container/upload`}
      beforeUpload={beforeUpload}
      {...rest}
    >
      {url ? (
        <img src={url} alt="avatar" style={{ width: '100%' }} />
      ) : (
        uploadButton
      )}
    </Upload>
  )
}

const UploadImage = ({
  name,
  label,
  formItemOptions = {},
  text = 'Upload',
}) => {
  const [loading, setLoading] = useState(false)
  const [imageUrl, setImageUrl] = useState('')

  const handleChange = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true)
      return
    }
    if (info.file.status === 'done') {
      console.log(info)
      // const imageUrl = info.file.response.originalname
      // setImageUrl(`${baseUrl}/api/Containers/witsawa-iot/download/${imageUrl}`)
      const imageUrl = info.file.response.storageUrl
      setImageUrl(`${imageUrl}`)

      setLoading(false)
      return imageUrl
    }
  }

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div className="ant-upload-text">{text}</div>
    </div>
  )

  return (
    <InputWrapper
      name={name}
      label={label}
      eventValueGetter={handleChange}
      {...formItemOptions}
    >
      <UploadComponent imageUrl={imageUrl} uploadButton={uploadButton} />
    </InputWrapper>
  )
}

UploadComponent.propTypes = {
  imageUrl: PropTypes.string,
  defaultValue: PropTypes.object,
  uploadButton: PropTypes.node,
}

UploadImage.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  formItemOptions: PropTypes.object,
  text: PropTypes.string,
}

export default UploadImage
